import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { orgmgrGql } from '@nemlia/hasura-gql';
const GET_MAINTENANCE_BANNER = orgmgrGql(/* GraphQL */`
  query STYRA_GET_MAINTENANCE_BANNER {
    ta_maintenance(where: { display_end: { _gte: "now()" }, show_in_web: { _eq: true } }) {
      id
      group_id
      type
      language
      text
      display_start
      display_end
      maintenance_start
      maintenance_end
      organisation_id
      published
      show_in_app
      show_in_web
    }
  }
`);
export const useGetMaintenanceBanner = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      pollInterval: 300000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useQuery(GET_MAINTENANCE_BANNER, t0);
  let t1;
  if ($[1] !== data) {
    t1 = {
      data
    };
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};